// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2SFmH","left":"StickyBox_left__1azr5","right":"StickyBox_right__24Kg9"};